import { queryOptions } from '@tanstack/react-query';
import { AccountService } from '@/features/auth/services/AccountService.ts';

export const userQueryKeys = {
  all: ['users'],
  current: () => [...userQueryKeys.all, 'current'],
  countries: () => [...userQueryKeys.all, 'countries'] as const,
};

export const userQueries = {
  getCurrentUser: () =>
    queryOptions({
      queryKey: userQueryKeys.current(),
      queryFn: AccountService.getCurrentUser,
    }),

  countries: () =>
    queryOptions({
      queryKey: userQueryKeys.countries(),
      queryFn: AccountService.getCountries,
      staleTime: Infinity,
    }),
};
